import React, { useEffect, useState } from "react";

function DTOClaims() {
  return <></>;
}
export default DTOClaims;
